import React from 'react'

const blank = () => {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh', 
      backgroundColor:'#151517' 
    }}>
      
    </div>
  )
}

export default blank;
